import { render, staticRenderFns } from "./ShopifyOrderDetails.vue?vue&type=template&id=2fc8b71a&"
import script from "./ShopifyOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ShopifyOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShopifyOrderDetails.vue"
export default component.exports